import React from "react";
import Statistics from "../../Admin/Statistics";

const StatisticsScreen = () => {
    return <Statistics />;
};

export default StatisticsScreen;
